import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { ActionService } from 'src/app/core/services/action.service';
import { LaunchDarklyService } from 'src/app/core/services/launchdarkly.service';
import { RouteService } from 'src/app/core/services/route.service';
import { LoadApplicationUsersDatatable } from 'src/app/core/state/_actions/application.actions';
import {
  AddExistingUser,
  CreateNewUser,
  InviteUser,
  LoadApplicationUsers,
  LoadProducts,
  UpdateApplicationUser,
  ValidUserEmail
} from 'src/app/core/state/_actions/settings/application-users.actions';
import { LoadRoles } from 'src/app/core/state/_actions/settings/roles.actions';
import { UpdateProfile } from 'src/app/core/state/_actions/user.actions';
import { OpTypes as OpType, Select2Data } from 'src/app/core/state/_models/general.model';
import {
  ApplicationUsers,
  ProductData,
  Products,
  RolesResponse
} from 'src/app/core/state/_models/settings.models';
import {
  getApplicationUserOperations,
  getProducts,
  getProductsLoading,
  getUserEmailValidity
} from 'src/app/core/state/_selectors/settings/application-users.selector';
import { getAllRoles, getAllRolesLoading } from 'src/app/core/state/_selectors/settings/roles.selector';
import { getUserOperations } from 'src/app/core/state/_selectors/user.selector';
import { EMAIL_PATTERN, NAME_PATTERN, PASSWORD_PATTERN, AT_LEAST_8_CHAR_PATTERN,
   INCLUDE_SPECIAL_CHAR_PATTERN, SPECIAL_CHAR_PATTERN } from 'src/app/shared/constants';
import { FEATURE_FLAGS } from 'src/app/shared/launchdarkly.constants';
import { Roles } from 'src/app/shared/enums/role.enum';
import { SubSink } from 'subsink';
import { OpTypes } from '../../../../../core/state/_models/application-users.model';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-upsert',
  templateUrl: './upsert-user.component.html',
  styleUrls: ['./upsert-user.component.scss'],
})
export class UpsertUserComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  @Input('actionType') actionType: string = '';
  @Input('userDetails') userDetails: ApplicationUsers | undefined = undefined;
  opType = OpTypes;
  form!: UntypedFormGroup;
  currentUserRole = '';
  Products: Array<Select2Data> = [];
  applicationRoles: Array<Select2Data> = [];
  topLevelRoles: Array<Select2Data> = [];
  // companyUsers: Array<Select2Data> = [];
  timeout: any = null;
  emailExists: boolean = false;
  newEvent = {
    ApplicationKey: this.route.getApplicationKey(),
    CompanyKey: null,
    Draw: 1,
    IsGroupingEnabled: false,
    Length: 50,
    Order: [],
    Search: { value: '', regex: false },
    Start: 0,
    Columns: [],
  };
  addExistingUserId: string = '';
  addExistingUserRole: string = '';
  phoneMask = '(000) 000-0000';
  isUpsertUserComponent:boolean = true;
  minLengthErrorMessage: string = 'Minimum 2 Characters Required'
  applicationRole = Roles;
  applicationKey:string = '';
  isAllRolesLoading :{[key:string]:boolean} = {};
  isProductsLoading:{[key:string]:boolean} = {};
  editUserPhoneNumberFixEnabled = false;

  constructor(
    private fb: UntypedFormBuilder,
    public route: RouteService,
    private modal: NgbModal,
    public store: Store,
    public action: ActionService,
    private readonly ldService: LaunchDarklyService
  ) {}

  ngOnInit(): void {
    this.applicationKey = this.route.getApplicationKey();
    this.subs.add(
      this.ldService
        .getFlagValue(FEATURE_FLAGS.ENABLE_EDIT_USER_PHONE_NUMBER_FIX, false)
        .subscribe((value) => {
          this.editUserPhoneNumberFixEnabled = !!value;
        })
    );
    this.getApiState();
    this.initForm();
    if(this.actionType === this.opType.INVITE_NEW_USER){
      this.store.dispatch(new LoadProducts());
    }
    this.store.dispatch(new LoadRoles(this.route.getApplicationKey()));
    this.loadSubscribers();
  }
  getApiState(){
    const combinedSubscription = combineLatest([
      this.store.pipe(select(getAllRolesLoading)),
      this.store.pipe(select(getProductsLoading)),
    ]).subscribe(([isAllRolesLoading, isProductsLoading]) => {
      this.isAllRolesLoading = isAllRolesLoading;
      this.isProductsLoading = isProductsLoading;
    });
    this.subs.add(combinedSubscription);
  }

  loadSubscribers = () => {
    this.subs.sink = this.store
      .pipe(
        select(getProducts),
        filter((products) => !!products),
        map((products) => products)
      )
      .subscribe((products: Products) => {
        if (products && products.data) {
          this.Products = [];
          products.data.forEach((product: ProductData) => {
            this.Products.push({ value: product.key, label: product.name });
          });
        }
      });

    this.subs.sink = this.store
      .pipe(
        select(getAllRoles),
        filter((roles) => !!roles[this.route.getApplicationKey()]),
        map((roles) => roles[this.route.getApplicationKey()])
      )
      .subscribe((roles) => {
        this.applicationRoles = [];
        roles?.forEach((role: RolesResponse) => {
          this.applicationRoles.push({ value: role.Key, label: role.Name });
        });
        this.applicationRoles.push({
          value: 'addNewRole',
          label: 'Create Role ...',
        });

        if (
          this.actionType == OpTypes.UPDATE_USER &&
          roles.length &&
          this.form
        ) {
          setTimeout(() => {
            this.form.patchValue({
              role: this.userDetails
                ? this.userDetails.ApplicationRolesIds[0]
                : null,
            });
          }, 0);
        }
      });

    // this.subs.sink = this.store
    //   .pipe(
    //     select(getUserApplications),
    //     filter((application) => !!application)
    //   )
    //   .subscribe((application: any) => {
    //     if (application) {
    //       var currentApplication = application.find(
    //         (s: any) => s.Id == this.route.getApplicationId()
    //       );
    //       if (currentApplication != undefined) {
    //         this.companyId = currentApplication.CompanyId;
    //         application.find;
    //       }
    //     }
    //   });
    // if (this.actionType === 'ADD_EXISTING_USER')
    //   this.store.dispatch(
    //     new LoadCompanyUsers(this.companyId, this.route.getApplicationId())
    //   );

    // this.subs.sink = this.store
    //   .pipe(select(getCompanyUsers))
    //   .subscribe((companyUsers: Array<CompanyUsers>) => {
    //     this.companyUsers = [];
    //     if (companyUsers) {
    //       companyUsers.forEach((user: CompanyUsers) => {
    //         this.companyUsers.push({ value: user.Id, label: user.Email });
    //       });
    //     }
    //   });

    this.subs.add(
    this.store
      .pipe(select(getUserEmailValidity))
      .subscribe((validEmail: any) => {
        if (validEmail != null) {
          if (validEmail.IsValid) {
            this.emailExists = false;
          } else {
            this.emailExists = true;
          }
        }
      }));
  };

  /**
   * Init form
   */
  initForm = () => {
    switch (this.actionType) {
      case this.opType.CREATE_USER:
        this.form = this.fb.group({
          FirstName: [null, [Validators.required,Validators.minLength(2),Validators.pattern(NAME_PATTERN)]],
          LastName: [null,[Validators.required,Validators.minLength(2),Validators.pattern(NAME_PATTERN)]],
          PhoneNumber: [null,[Validators.required,Validators.pattern('[0-9]{10}')]],
          Email: [null, [Validators.required, Validators.maxLength(100), Validators.email,Validators.pattern(EMAIL_PATTERN)]],
          Password: ['', Validators.required],
          Role: [null, Validators.required],
          ApplicationIds: [null],
          ApplicationRoleIds: [null],
          IsExternalUser: [false]
        });
        this.subs.add(
        this.form.controls.Role.valueChanges.subscribe((val: any) => {
          if (val != undefined && val == 'participant') {
            this.form.controls.ApplicationRoleIds.setValidators([
              Validators.required,
            ]);
            this.form.controls.ApplicationRoleIds.updateValueAndValidity({
              emitEvent: false,
            });
          } else if (val != undefined && val == 'admin') {
            this.form.controls.ApplicationRoleIds.clearValidators();
            this.form.controls.ApplicationRoleIds.updateValueAndValidity({
              emitEvent: false,
            });
          }
        }),
        this.form.controls['IsExternalUser']?.valueChanges.subscribe(
          (val: any) => {
            if (!val) {
              this.form.controls.Password.setValidators(Validators.required);
              this.form.controls.Password.updateValueAndValidity();
            } else {
              this.form.controls.Password.clearValidators();
              this.form.controls.Password.updateValueAndValidity();
            }
          }
        ));

        this.pwdUpdateValidators();
        this.validateUserEmail();
        break;
      case this.opType.INVITE_NEW_USER:
        this.form = this.fb.group({
          Email: [null, [Validators.required, Validators.email,Validators.pattern(EMAIL_PATTERN)]],
          IsAdmin: [false],
          BillingAdmin: [false],
          StripeProductId: [null],
          ApplicationRoleIds: [null],
          IsExternalUser: [false]
        });
        break;
      case this.opType.ADD_EXISTING_USER:
        this.form = this.fb.group({
          UsersId: ['', Validators.required],
          ApplicationRoleIds: [null],
        });
        break;
      case this.opType.UPDATE_USER:
        this.form = this.fb.group({
          UserId: [
            { value: this.userDetails?.Email, disabled: true },
            Validators.required,
          ],
          IsAdmin: [
            Boolean(this.userDetails ? this.userDetails.IsAdmin : false),
          ],
          role: [null],
          FirstName:[this.userDetails?.FirstName || '',[Validators.required,Validators.minLength(2),Validators.pattern(NAME_PATTERN)]],
          LastName:[this.userDetails?.LastName || '',[Validators.required,Validators.minLength(2),Validators.pattern(NAME_PATTERN)]],
          PhoneNumber:[this.userDetails?.PhoneNumber?.slice(1),Validators.required],
        });
        if(!(this.userDetails?.IsAdmin || this.userDetails?.IsSuperAdmin)){
          this.form.controls.role.setValidators(Validators.required);
        }
        this.subs.add(
        this.form.controls['role']?.valueChanges.subscribe(
          (val: any) => {
            if (val != undefined && val == 'addNewRole') {
              this.route.navigate([
                '/apps',
                  this.route.getApplicationKey(),
                  'settings','user-management','roles','create'
              ]);
            }
          }
        ),
        this.form.controls['IsAdmin']?.valueChanges.subscribe(
          (val: any) => {
            if (!val) {
              this.form.controls.role.setValidators(Validators.required);
              this.form.controls.role.updateValueAndValidity();
            } else {
              this.form.controls.role.clearValidators();
              this.form.controls.role.updateValueAndValidity();
            }
          }
        ));
        break;
      default:
        this.form = this.fb.group({});
    }

    this.subs.add(
    this.form.controls['ApplicationRoleIds']?.valueChanges.subscribe(
      (val: any) => {
        if (val != undefined && val == 'addNewRole') {
          this.route.navigate([
            '/apps',
              this.route.getApplicationKey(),
              'settings','user-management','roles','create'
          ]);
        }
      }
    ));

    this.topLevelRoles.push({ value: 'admin', label: 'Admin' });
    this.topLevelRoles.push({ value: 'participant', label: 'Participant' });
  };

  validateUserEmail = () => {
    this.setEmailFieldValidators('Email');
  };

  setEmailFieldValidators = (field: string) => {
    this.subs.add(
    this.form.controls[field].valueChanges.subscribe((email) => {
      if (email) {
        // if email in not empty
        for (let field in this.form.controls)
          if (field.toLowerCase().includes('email')) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              this.store.dispatch(
                new ValidUserEmail({ value: this.form.controls.Email.value })
              );
            }, 900);
          }
      }
    }));
  };

  pwdUpdateValidators = () => {
    this.setPasswordFieldsValidators('Password');
  };

  setPasswordFieldsValidators = (field: string) => {
    this.subs.add(
    this.form.controls[field].valueChanges.subscribe((password) => {
      if (password) {
        for (let field in this.form.controls)
          if (field.toLowerCase().includes('password')) {
            this.form.controls[field].setValidators([
              Validators.required,
              Validators.pattern(PASSWORD_PATTERN),
              Validators.pattern(INCLUDE_SPECIAL_CHAR_PATTERN),
              Validators.pattern(AT_LEAST_8_CHAR_PATTERN),
              Validators.pattern(SPECIAL_CHAR_PATTERN),
            ]);
            this.form.controls[field].updateValueAndValidity({
              emitEvent: false,
            });
          }
      }
       else {
        for (let field in this.form.controls)
          if (field.toLowerCase().includes('password')) {
            this.form.controls[field].clearValidators();
            this.form.controls[field].updateValueAndValidity({
              emitEvent: false,
            });
          }
      }
    }));
  };

  get formControls() {
    return this.form?.controls;
  }

  /** Form snapshot for edit-user save/compare; includes disabled controls when FF is on (GABSW-2409). */
  private getUpdateUserFormValues(): Record<string, any> {
    return this.editUserPhoneNumberFixEnabled
      ? this.form.getRawValue()
      : this.form.value;
  }

  formSubmit = async () => {
    if (this.addExistingUserId != '') {
      try {
        let payload = {
          ...this.form.getRawValue(),
          ApplicationKey: this.route.getApplicationKey(),
          UsersId: this.addExistingUserId,
        };
        await this.action.dispatch(
          OpTypes.ADD_EXISTING_USER,
          new AddExistingUser(payload),
          getApplicationUserOperations
        );
        this.close(true);
      } catch (err) {}
    }
  };

  updateFormSubmit = async () => {
    try {
      if(this.applicationRoleComparision() && this.applicationProfileChange()){
        await this.updateRoleForUser();
        await this.updateUserProfile();
      } else if(this.applicationProfileChange()){
        await this.updateUserProfile();
      } else if (this.applicationRoleComparision()){
        await this.updateRoleForUser();
      }
      this.close(true);
    } catch (err) {}
  };

  /**
   * Get Modal Title
   */
  getTitle = (): string => {
    switch (this.actionType) {
      case OpTypes.ADD_EXISTING_USER:
        return 'Add User';
      case OpTypes.INVITE_NEW_USER:
        return 'Invite User';
      case OpTypes.UPDATE_USER:
        return 'Edit User';
      case OpTypes.CREATE_USER:
        return 'Create User';
      default:
        return 'Add User';
    }
  };

  /**
   * Remove Role
   */
  removeRole = (): void => {
    this.form.patchValue({
      role: [null],
    });
  };

  /**
   * Close all modal
   */

  inviteUserSubmit = async () => {
    try {
      const rawValue = this.form.getRawValue();
      let payload = {
        ...rawValue,
        ApplicationRolesKey: !rawValue.IsAdmin ? rawValue.ApplicationRoleIds : '',
        IsAdmin: rawValue.IsAdmin ? 1 : 0,
        IsExternalUser: rawValue.IsExternalUser ? 1 : 0,
        BillingAdmin: rawValue.BillingAdmin ? 1 : 0,
        ApplicationKey: this.route.getApplicationKey(),
      };

      await this.action.dispatch(
        OpTypes.INVITE_NEW_USER,
        new InviteUser(payload),
        getApplicationUserOperations
      );
      this.close(true);
    } catch (err) {}
  };

  createUserSubmit = async () => {
    try {
      const rawValue = this.form.getRawValue();
      let formPayload = {
        ...rawValue,
        PhoneNumber:rawValue.PhoneNumber ? 1+rawValue.PhoneNumber : null,
        ApplicationIds: this.route.getApplicationKey(),
      };
      var payload = [];
      payload.push(formPayload);
      payload[0].ApplicationIds = [payload[0].ApplicationIds.toString()];
      payload[0].ApplicationRoleIds =
        payload[0].ApplicationRoleIds != null && payload[0].Role !== 'admin'
          ? [payload[0].ApplicationRoleIds.toString()]
          : [];
      await this.action.dispatch(
        OpTypes.CREATE_USER,
        new CreateNewUser(payload),
        getApplicationUserOperations
      );
      this.close(true);
      this.store.dispatch(
        new LoadApplicationUsers(this.route.getApplicationKey())
      );
    } catch (err) {}
  };

  close = (isSubmit:boolean = false) => {
    this.modal.dismissAll(isSubmit);
    if(isSubmit){
      this.store.dispatch(new LoadApplicationUsersDatatable(this.newEvent, true));
    }
  };

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  setSelectedValue = (event: any, fg: UntypedFormGroup) => {
    if (event != null && event != undefined) {
      this.addExistingUserId = event.value;
      this.addExistingUserRole = event.value2;
      if(this.addExistingUserRole === Roles.participant){
        this.form.controls.ApplicationRoleIds.setValidators(Validators.required);
        this.form.controls.ApplicationRoleIds.updateValueAndValidity();
      } else {
        this.form.controls.ApplicationRoleIds.removeValidators(Validators.required);
        this.form.controls.ApplicationRoleIds.updateValueAndValidity();

      }
    }
  };

  async updateRoleForUser(){
    const formValues = this.getUpdateUserFormValues();
    let selectRole = undefined;

    const matchedRole = formValues.role
    ? this.applicationRoles.find((role: Select2Data) => role.value == formValues.role)
    : undefined; 

    let updateRolePayload: Record<string, any> = {
      ...this.userDetails,
      IsAdmin: Number(formValues.IsAdmin),
      Role: matchedRole?.label ?? null,
      ApplicationRolesIds: formValues.role
        ? [formValues.role]
        : [0],
      ApplicationKey: this.route.getApplicationKey(),
    };
    if (this.editUserPhoneNumberFixEnabled) {
      updateRolePayload.FirstName = formValues.FirstName;
      updateRolePayload.LastName = formValues.LastName;
      updateRolePayload.PhoneNumber = formValues.PhoneNumber
        ? 1 + formValues.PhoneNumber
        : this.userDetails?.PhoneNumber;
    }
    delete updateRolePayload.IsSuperAdmin;
    await this.action.dispatch(
      OpTypes.UPDATE_USER,
      new UpdateApplicationUser(this.route.getApplicationKey(), updateRolePayload),
      getApplicationUserOperations
    );
  }

  async updateUserProfile(){
    const formValues = this.getUpdateUserFormValues();
    let updateProfilePayload:any = {
      Email: this.userDetails?.Email,
      FirstName: formValues.FirstName,
      LastName: formValues.LastName,
      PhoneNumber: 1 + formValues.PhoneNumber,
      FromSettings:true,
    }
   
    await this.action.dispatch(
      OpType.UPDATE,
      new UpdateProfile(updateProfilePayload),
      getUserOperations
    );
  }

  applicationRoleComparision(){
    const formValues = this.getUpdateUserFormValues();
    if (this.editUserPhoneNumberFixEnabled) {
      return Boolean(formValues.IsAdmin) !== Boolean(this.userDetails?.IsAdmin) ||
        formValues.role !== this.userDetails?.ApplicationRolesIds[0];
    }
    return formValues.IsAdmin !== this.userDetails?.IsAdmin ||
      formValues.role !== this.userDetails?.ApplicationRolesIds[0];
  }
  applicationProfileChange(){
    const formValues = this.getUpdateUserFormValues();
    return formValues.FirstName !== this.userDetails?.FirstName ||
      formValues.LastName !== this.userDetails?.LastName ||
      (1 + formValues.PhoneNumber) != this.userDetails?.PhoneNumber;
  }
}
